﻿import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class UrlInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(request.url.includes('http') || request.url.toLocaleUpperCase().includes('.JSON'))
    {
      return next.handle(request);
    }

    request = request.clone({url: `${environment.apiUrl}${request.url}`});

    return next.handle(request);
  }
}
